module.exports = __webpack_public_path__ + "static/media/logistics.a50d4796.svg";